/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Condition_FieldInputs */

const cs_automation_condition_field = /** @type {(inputs: Automation_Condition_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole podmínky`)
};

const en_automation_condition_field = /** @type {(inputs: Automation_Condition_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condition field`)
};

/**
* | output |
* | --- |
* | "Condition field" |
*
* @param {Automation_Condition_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_condition_field = /** @type {((inputs?: Automation_Condition_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Condition_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_condition_field(inputs)
	return cs_automation_condition_field(inputs)
});